<template>
    <div class="board-view__page">
        <div :class="`board-view__move prev ${articleInfo.prevArticle ? '' : 'active'}`">
            <div class="board-view__move--tit"><p>이전 글</p></div>
            <a href="javascript:;" class="board-view__move--link" @click="goArticle(articleInfo.prevArticle)" v-if="articleInfo.prevArticle">
                <p>{{ $commonUtils.getTitle(articleInfo.prevArticle) }}</p>
            </a>
            <a href="javascript:;" class="board-view__move--link" v-else>이전 글이 없습니다.</a>
        </div>
        <div :class="`board-view__move next ${articleInfo.nextArticle ? '' : 'active'}`">
            <div class="board-view__move--tit"><p>다음 글</p></div>
            <a href="javascript:;" class="board-view__move--link" @click="goArticle(articleInfo.nextArticle)" v-if="articleInfo.nextArticle">
                <p>{{ $commonUtils.getTitle(articleInfo.nextArticle) }}</p>
            </a>
            <a href="javascript:;" class="board-view__move--link" v-else>다음 글이 없습니다.</a>
        </div>
    </div>
</template>
<script>
export default{
    props: {
        articleInfo: ''
    },
    data() {
        return {
            
        }
    },
    mounted() {
        
    },
    methods: {
        goArticle(article) {
            this.$router.push({
                path: this.$route.path,
                query: { boardNo: this.boardNo, articleNo: article.articleNo }
            });
        },
    },
}
</script>